import React, { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { BASE_URL } from '../config';
import axios from 'axios';

function PaymentResponse() {
    const [mode, setMode] = useState("");
    const [trnsID, setTrnsID] = useState("");
    let { status } = useParams();
    let location=useLocation();

    let fetchData=async(st,id)=>{

        let data =new FormData();
        data.append('status', st);
        data.append('orderid', id); 
        var config = {
            method: 'post',
            url: `${BASE_URL}/api/order`,
            headers: { 
              'X-Auth-Token': '12345', 
            },
            data : data
          };

          await axios(config)
          .then(function (response) {
                console.log(response.data)
          })

    }
    useEffect(() => {
        let queryParams=new URLSearchParams(location.search);
        setMode(status);
        setTrnsID(queryParams.get('id'));
        fetchData(status,queryParams.get('id'));
        console.log(status)
    }, [])
    return (
        <div className="payment-container">
            {mode==="successfull"&&<div className="payment-card">
                <div style={{ borderRadius: 200, height: 200, width: 200, background: '#F8FAF5', margin: '0 auto' }}>
                    <i className="checkmark">✓</i>
                </div>
                <h1>Success</h1>
                <p>We received your purchase request;<br /> we'll be in touch shortly! </p>
            </div>}
            {mode==="failed"&&
            <div className="payment-card">
            <div style={{ borderRadius: 200, height: 200, width: 200, background: '#F8FAF5', margin: '0 auto' }}>
                <i className="checkmark" style={{color:"white"}}>❌</i>
            </div>{console.log(trnsID)}
            <h1 style={{color:"#d75a4a"}}>Failed</h1>
            <p>Sorry!! Your transaction has been failed.</p>
        </div>
            }
        </div>

    )
}

export default PaymentResponse